import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d4cef2e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text--center caption" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Неверный код", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Вы исчерпали все попытки. Попробуйте позже", -1))
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { key: 3 }
const _hoisted_7 = { class: "mt-4" }
const _hoisted_8 = { class: "mt-4 text--center" }
const _hoisted_9 = { class: "mt-8 text--center" }

import { ref, computed, watch } from 'vue';
import PinCode from '@/views/auth/components/PinCode.vue';
import PinRepeat from '@/views/auth/components/PinRepeat.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'EnterPinCode',
  props: {
  hasError: {
    type: Boolean,
    default: false,
  },
  isPinAlive: {
    type: Boolean,
    default: false,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  tokenPhone: {
    type: String,
    default: '',
  },
  tokenLock: {
    type: Number,
    default: 0,
  },
  temporaryBanned: {
    type: Boolean,
    default: false,
  },
  lastAttempt: {
    type: Boolean,
    default: false,
  },
},
  emits: ['update:pin', 'goToLogin', 'changePhone', 'submit', 'repeatSubmit'],
  setup(__props, { emit }) {

const props = __props;





const pin = ref('');
const isFieldDisabled = computed(() => props.isPinAlive || props.loading);

const changePhone = () => emit('changePhone');
const goToLogin = () => emit('goToLogin');
const repeatSubmit = () => emit('repeatSubmit');
const updatePin = () => emit('update:pin', pin.value);

watch(pin, () => {
  if (pin.value.length === 4) {
    emit('submit', pin.value);
  }
});

return (_ctx: any,_cache: any) => {
  const _component_UiButton = _resolveComponent("UiButton")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(PinCode, {
      ref: "pinCode",
      modelValue: pin.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((pin).value = $event)),
      disabled: _unref(isFieldDisabled),
      onInput: updatePin
    }, null, 8, ["modelValue", "disabled"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("p", {
        class: _normalizeClass(["auth-view--error text--small text--center error--text mt-2", { active: __props.isPinAlive || __props.hasError }])
      }, [
        (__props.temporaryBanned)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, "Вы исчерпали все попытки. Попробуйте позже"))
          : (__props.lastAttempt)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _hoisted_3,
                _hoisted_4
              ], 64))
            : (__props.isPinAlive)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, "Срок действия кода истек"))
              : (_openBlock(), _createElementBlock("span", _hoisted_6, "Неверный код"))
      ], 2),
      _createElementVNode("p", _hoisted_7, "Код отправлен на " + _toDisplayString(__props.tokenPhone), 1),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_UiButton, {
          size: "small",
          type: "link",
          class: "button-change-phone",
          onClick: changePhone
        }, {
          default: _withCtx(() => [
            _createTextVNode("Изменить номер")
          ]),
          _: 1
        })
      ]),
      _createVNode(PinRepeat, {
        class: "mt-2",
        lock: __props.tokenLock,
        onSubmit: repeatSubmit
      }, null, 8, ["lock"])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_UiButton, {
        size: "large",
        type: "link",
        onClick: goToLogin
      }, {
        default: _withCtx(() => [
          _createTextVNode("На страницу входа")
        ]),
        _: 1
      })
    ])
  ]))
}
}

})